
















import { Vue, Component, Watch } from 'vue-property-decorator';
import { Socket } from 'vue-socket.io-extended';
import { getModule } from 'vuex-module-decorators';
import GameModule from '@/store/modules/Game';
import Table from '@/components/Table/Index.vue';
import UserOnlineBody from '@/components/Table/UserOnlineBody.vue';
import UserOnlineData from '@/data/UserOnlineData';
import utils from '@/services/utils';

@Component({
  components: {
    Table,
    UserOnlineBody,
  },
})
export default class UserOnlineView extends Vue {
  GameInstance = getModule(GameModule, this.$store);

  utilsInstance = utils;

  TableHead = UserOnlineData.TableHead;

  summaryPlayerData: any = [];

  summaryBotData: any = [];

  userOnline: any = [];

  botOnline: any = [];

  gamesList: any = [];

  mode = 'Players';

  created() {
    this.utilsInstance.socketConnect(this.utilsInstance.getUserPersistent().token);
    this.emitGetPlayerOnline();
  }

  setMode(val) {
    this.mode = val;
    if (this.mode === 'Bots') {
      this.emitGetBotOnline();
    } else {
      this.emitGetPlayerOnline();
    }
  }

  emitGetPlayerOnline() {
    Vue.prototype.$socket.client.emit('getAgentPlayersNumber', {}, (res) => {
      this.userOnline = JSON.parse(atob(res.data)).data;
      this.getGames();
    });
  }

  emitGetBotOnline() {
    Vue.prototype.$socket.client.emit('getAgentBotsNumber', {}, (res) => {
      this.botOnline = JSON.parse(atob(res.data)).data;
      this.getGames();
    });
  }

  async getGames() {
    await this.GameInstance.FetchGame();
    this.gamesList = this.GameInstance.game;
    if (this.mode === 'Players') {
      this.updatePlayerOnline();
    } else {
      this.updateBotOnline();
    }
  }

  @Watch('$i18n.locale')
  onLanguagChange() {
    this.updatePlayerOnline();
  }

  async updatePlayerOnline() {
    this.summaryPlayerData = await this.gamesList
      .map((v) => ({
        activeUser: this.userOnline[v.prefix] ? this.userOnline[v.prefix].players : 0,
        name: v.name[this.$i18n.locale],
      }));
    this.summaryPlayerData
      .push({
        activeUser: this.userOnline.LOBBY.players,
        name: this.$i18n.locale === 'th' ? 'ล็อบบี้' : 'LOBBY',
      });
    this.summaryPlayerData
      .sort((a, b) => b.activeUser - a.activeUser);
  }

  updateBotOnline() {
    this.summaryBotData = this.gamesList.map((v) => ({
      activeUser: this.botOnline[v.prefix] ? this.botOnline[v.prefix].players : 0,
      name: v.name.en,
    }));
  }

  @Socket('updateAgentPlayersNumber')
  onUpdatePlayer(res) {
    this.userOnline = JSON.parse(atob(res.data)).data;
    this.updatePlayerOnline();
  }

  @Socket('updateAgentBotsNumber')
  onUpdateBot(res) {
    this.botOnline = JSON.parse(atob(res.data)).data;
    this.updateBotOnline();
  }
}
